<template>
  <div class="layout">
    <el-container>
      <el-header>
        <div class="top">
          <div class="logo">
            <img src="@/assets/img/logo_admin.png" />
          </div>
          <div class="setbox">
            <div class="loginout" @click="editpwd">
              {{ userInfo.roleid == 2 ? 'ResetPWD' : '修改密码' }}
            </div>
            <div class="loginout" @click="loginout">
              {{ userInfo.roleid == 2 ? english['注销账号'] : '退出账号' }}
            </div>
          </div>
        </div>
      </el-header>
      <el-container>
        <el-aside width="200px;">
          <el-menu
            ref="menus"
            :default-active="defaultmenuclick"
            :unique-opened="true"
            class="el-menu-vertical-demo"
            background-color="#545c64"
            text-color="#fff"
            active-text-color="#fff"
          >
            <el-submenu
              :index="String(i + 1)"
              v-if="item.sub && item.sub.length > 0"
              v-for="(item, i) in menus"
              :key="i"
            >
              <template slot="title">
                <span>{{ item.name }}</span>
              </template>
              <el-menu-item
                @click="menuclick(sitem, i)"
                v-for="(sitem, si) in item.sub"
                :key="si"
                :index="i + 1 + '-' + (si + 1)"
                >{{ sitem.name }}</el-menu-item
              >
            </el-submenu>
            <el-menu-item
              v-for="(item, i) in menus"
              v-if="!item.sub"
              :key="item.name"
              @click="menuclick(item, i)"
              :index="String(i + 1)"
            >
              {{ userInfo.roleid == 2 ? english[item.name] : item.name }}
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-container>
          <el-main><router-view></router-view></el-main>
        </el-container>
      </el-container>
    </el-container>
    <el-dialog :title="userInfo.roleid == 2 ? 'ResetPWD' : '修改密码'" :visible.sync="pwdflag" width="500px" center>
      <div class="dialogitem">
        <el-input :placeholder="userInfo.roleid == 2 ? 'oldpassword' : '旧密码'" v-model="oldpwd" show-password>
          <template slot="prepend">{{ userInfo.roleid == 2 ? 'oldpassword' : '旧密码' }}</template>
        </el-input>
      </div>
      <div class="dialogitem">
        <el-input :placeholder="userInfo.roleid == 2 ? 'newpassword' : '新密码'" v-model="newpwd" show-password>
          <template slot="prepend">{{ userInfo.roleid == 2 ? 'newpassword' : '新密码' }}</template>
        </el-input>
      </div>
      <div class="dialogitem">
        <el-input
          :placeholder="userInfo.roleid == 2 ? 'newpassword again' : '再次输入新密码'"
          v-model="newpwd2"
          show-password
        >
          <template slot="prepend">{{ userInfo.roleid == 2 ? 'newpassword again' : '再次输入新密码' }}</template>
        </el-input>
      </div>
      <div class="dialogitem" style="text-align: center">
        <el-button type="primary" size="small" @click="submitpwd">{{
          userInfo.roleid == 2 ? 'submit' : '提交'
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getJapiServerData, getServerData } from '@/util/data/';
import Config from '@/util/config';

export default {
  props: {
    title: String,
  },
  data() {
    return {
      menus: [],
      userInfo: [],
      defaultmenuclick: '1-1',
      oldpwd: '',
      newpwd: '',
      newpwd2: '',
      pwdflag: false,
      english: {
        课时列表: 'Lesson Schedule',
        我的课表: 'Myschedule',
        课程详情: 'Detail',
        注销账号: 'Login Out',
      },
    };
  },
  computed: {},
  mounted() {
    this.setViewportZoom(0);
    const userinfo = JSON.parse(localStorage.getItem('userinfo'));
    if (!userinfo) {
      this.$message.error('用户信息过期，请重新登陆');
      this.$router.push('/login');
    }

    const url = 'japi/class/page?name=&page=1';
    const params = {};
    getJapiServerData(
      url,
      params,
      'GET',
      (res) => {
        console.log('pduser', res);
      },
      0.5,
    );
    this.userInfo = userinfo;
    this.defaultmenuclick = userinfo.roleid == 2 || userinfo.roleid == 3 ? '1' : '1-1';
    // console.log('userinfo', userinfo, this.$router)
    this.menus = userinfo.role.menus;
    if (userinfo.roleid == 2 || userinfo.roleid == 3) {
      this.menus.forEach((item, i) => {
        const url = item.url.split('/')[1];
        if (this.$route.path.substr(1, 99) == url.substr(0, url.indexOf('.'))) {
          this.defaultmenuclick = String(i + 1);
        }
      });
    } else {
      this.menus.forEach((bitem, bi) => {
        bitem.sub.forEach((item, i) => {
          const url = item.url.split('/')[1];
          if (this.$route.path.substr(1, 99) == url.substr(0, url.indexOf('.'))) {
            this.defaultmenuclick = bi + 1 + '-' + (i + 1);
          }
        });
      });
    }
  },
  methods: {
    submitpwd() {
      if (this.oldpwd == '') {
        this.$message.error('旧密码不能为空！');
        return;
      }

      if (this.newpwd == '') {
        this.$message.error('新密码不能为空！');
        return;
      }

      if (this.newpwd != this.newpwd2) {
        this.$message.error('两次密码不一样！');
        return;
      }

      const url = Config.url.efunapi.url;
      const method = 'EFUNAPI_UPDATEPASSWORD';
      const params = {
        id: this.userInfo.id + '',
        oldpassword: this.oldpwd + '',
        newpassword: this.newpwd + '',
      };
      getServerData(
        url,
        method,
        params,
        (result) => {
          console.log('editpwd', result);
          this.$message.success('修改成功');
          setTimeout(() => {
            this.$router.push('/login');
          }, 200);
        },
        0.5,
      );
    },
    editpwd() {
      this.pwdflag = true;
    },
    setViewportZoom(scale) {
      var metaTag = document.querySelector('meta[name="viewport"]');
      if (metaTag) {
        // 设置或更新meta标签的内容
        metaTag.setAttribute(
          'content',
          'width=device-width, initial-scale=' + scale + ', maximum-scale=1, user-scalable=yes',
        );
      } else {
        // 如果不存在，则创建一个新的meta标签
        metaTag = document.createElement('meta');
        metaTag.setAttribute('name', 'viewport');
        metaTag.setAttribute(
          'content',
          'width=device-width, initial-scale=' + scale + ', maximum-scale=1, user-scalable=yes',
        );
        document.head.appendChild(metaTag);
      }
    },
    menuclick(e, i) {
      console.log(e);
      const url = e.url.split('/')[1];
      this.$router.push('/' + url.substr(0, url.indexOf('.')));
    },
    loginout() {
      localStorage.setItem('userinfo', '');
      localStorage.setItem('token', '');
      setTimeout(() => {
        this.$message.success('注销成功');
        this.$router.push('/login');
      }, 500);
    },
  },
};
</script>

<style lang="less" scoped>
.layout {
  height: 100%;
  width: 100%;
  min-width: 1400px;

  .top {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    align-items: center;
    background-color: #545c64;
    color: #fff;

    img {
      width: 150px;
    }

    .setbox {
      width: calc(100% - 200px);
      display: flex;
      justify-content: flex-end;

      .loginout {
        cursor: pointer;
        margin-left: 20px;
      }
    }
  }

  .mainWrap {
    height: calc(100% - 70px);
    overflow-y: auto;
  }
}

/deep/ .dialogitem {
  margin-top: 20px;
}

/deep/ .el-header {
  padding: 0;
  height: 73px !important;
}

/deep/ .el-container {
  height: 100%;
}

/deep/ .el-aside {
  min-width: 200px;
}

/deep/ .el-submenu__title i {
  // color: #409EFF !important;
}

/deep/ .el-menu {
  background-color: transparent;
  color: white;
  width: calc(100% + 2px);

  .el-menu-item,
  .el-sub-menu,
  .el-sub-menu__title {
    text-align: left;
    color: white;
  }

  .el-menu-item:hover {
    background-color: #00816d;
    color: white;
  }

  .el-menu-item:nth-child(1):hover {
    background-color: transparent;
  }
}

/deep/ .el-aside {
  background-color: #545c64;
  margin-top: -1px;
}

/deep/ .el-submenu__title {
  display: flex;
}

/deep/ .el-button {
  font-size: 14px !important;
}

/deep/ .el-menu-item.is-active {
  background-color: #409eff !important;
}
</style>
